module.exports = __webpack_public_path__ + "2ceaf5097fa652ff701674bba57107ce.MP3";